import { ReactElement, useCallback } from 'react';
import { Stack, Typography, Button } from '@mui/material';
import WarningIcon from '@mui/icons-material/WarningAmber';
import { useSnackbar } from 'notistack';

import { useAppDispatch, useToggle, useLazyRequest } from '~hooks/index';
import { resetAuth } from '~store/slices/auth';
import { resetHome } from '~store/slices/home';
import { deleteUpdateAdminCompany } from '~services/admin/company';
import DialogConfimation from '~components/DialogConfimation';

import { DialogConfigAndPreferencesSectionCard } from '../styles';

const messageConfirm = 'La compañia sera dada de baja';
const waringText =
  // eslint-disable-next-line max-len
  'Recuerda dar de baja la compañia es una acción irreversible no podrás recuperar la compañia una vez dada de baja';

const DialogConfigAndPreferencesSectionDangerZone = (): ReactElement => {
  const dispatch = useAppDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const [openConfirmDeleteUser, toggleOpenConfirmDeleteUser] = useToggle();

  const [, loadingDeleteCompany, , executeDeleteCompany] = useLazyRequest({
    request: deleteUpdateAdminCompany,
    withPostSuccess: () => {
      const message = 'Compañia dada de baja correctamente, nos vemos';

      enqueueSnackbar(message, { variant: 'success' });

      dispatch(resetAuth()); // Logout current user
      dispatch(resetHome());
      localStorage.removeItem('routix-new-ui');
    },
    withPostFailure: () => {
      enqueueSnackbar(
        'No se pudo dar de baja la compañia, intente nuevamente',
        { variant: 'error' },
      );
    },
  });

  const handleDeleteCompany = useCallback(() => {
    executeDeleteCompany(null);
  }, [executeDeleteCompany]);

  return (
    <DialogConfigAndPreferencesSectionCard isDanger>
      <Stack spacing={2}>
        <Stack spacing={1}>
          <Stack spacing={1} direction="row" alignItems="center">
            <WarningIcon color="error" />

            <Typography
              variant="h6"
              component="h5"
              fontWeight="bold"
              color="error.main"
            >
              Zona de Peligro
            </Typography>
          </Stack>

          <Typography variant="body2" color="text.secondary">
            Las acciones de esta sección son irreversibles. Procede con extrema
            precaución.
          </Typography>
        </Stack>

        <DialogConfigAndPreferencesSectionCard isDanger withBackGround small>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <Stack>
              <Typography
                variant="body1"
                color="text.secondary"
                fontWeight="bold"
              >
                Dar de baja la compañia
              </Typography>

              <Typography variant="caption" color="text.secondary">
                Borra permanentemente todos tus datos.
              </Typography>
            </Stack>

            <Button
              variant="contained"
              color="error"
              onClick={() => toggleOpenConfirmDeleteUser(true)}
            >
              Dar de baja
            </Button>
          </Stack>
        </DialogConfigAndPreferencesSectionCard>

        <DialogConfimation
          open={openConfirmDeleteUser}
          description={messageConfirm}
          warningText={waringText}
          onConfirm={handleDeleteCompany}
          onCancel={() => toggleOpenConfirmDeleteUser(false)}
          loadingConfirm={loadingDeleteCompany}
        />
      </Stack>
    </DialogConfigAndPreferencesSectionCard>
  );
};

export default DialogConfigAndPreferencesSectionDangerZone;
